import http from '../utils/httpRequest';

const apiGetDeptTree = (params) => {
    return http.get('/config/sysDeptDataPermisionConfig/deptTree')
}
const apiGetDeptDataPermisionConfig = (params) => {
    return http.get('/config/sysDeptDataPermisionConfig/listDeptDataPermisionConfig?deptId=' + params.deptId)
}
const apiPostChangeData = (params) => {
    return http.post('/config/sysDeptDataPermisionConfig/changeDataPermissionConfigs', params)
}
const apiGetdeleteDeptDataPermision = (params) => {
    return http.get('/config/sysDeptDataPermisionConfig/deleteDeptDataPermisionConfig?deptId=' + params.deptId)
}
const apiGetUserDeptTree = (params) => {
    return http.get('/config/sysDeptDataPermisionConfig/userDeptTree')
}
const apiPostSaveList = (params) => {
    return http.post('/configs/handleRules/saveList', params)
}
const apiGetHandleRules = (params) => {
    return http.post('/configs/handleRules/list', params)
}
const apiSaveCustomizationLists = (params) => {
    return http.post('/configs/handleRules/saveCustomizationList', params)
}
const apiGetCustomizationList = (params) => {
    return http.post('/configs/handleRules/getCustomizationList', params)
}
const apiGetHandleLevel = (params) => {
    return http.get('/configs/handleRules/getHandleLevel')
}
export {
    apiGetDeptTree,//获取部门树
    apiGetDeptDataPermisionConfig,//根据部门id 获取对应权限树数据
    apiPostChangeData,// 变更
    apiGetdeleteDeptDataPermision,// 删除部门数据权限
    apiGetUserDeptTree,
    apiPostSaveList,// 保存审批流
    apiGetHandleRules,// 获取单条审批流
    apiSaveCustomizationLists,
    apiGetCustomizationList,
    apiGetHandleLevel
}